export const rootSagas = [
    'catalog',
    'compatibility-chooser',
    'content',
    'cookie',
    'cordial',
    'cosmic-profile',
    'daily-updates',
    'deck',
    'forecast',
    'ga',
    'hexagram',
    'horoscope',
    'i-ching-reading',
    'karmacoin-store',
    'location',
    'member/email-preferences',
    'member/email-unsub',
    'member/privacy-policy-consent',
    'moon-phase',
    'number',
    'oranum',
    'planet-tracker',
    'price',
    'product-message',
    'promo-message',
    'promo-tracker',
    'raven',
    'recaptcha',
    'route',
    'subscription',
    'tarot-ga',
    'tarot-reading',
    'tcod',
    'user/index',
].map(name => require(`./${name}`).root);



// WEBPACK FOOTER //
// ./app/sagas/index.js